import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'myt-common-dashbaord',
    
    templateUrl: './common-dashbaord.component.html',
    styleUrl: './common-dashbaord.component.scss'
})
export class CommonDashbaordComponent implements OnInit {
  constructor(private utilsService: UtilsService) {
    this.utilsService.redirectUserToDashboard();
  }

  ngOnInit(): void {
  }
}
